"use client";

import { Modal, Button } from "antd";
import { CheckOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

const FeedbackModal = ({
  visible,
  type = "success",
  title,
  message,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryAction,
  onSecondaryAction,
  onClose,
}) => {
  // Default values based on type
  const defaultValues = {
    success: {
      title: "Successful",
      message: "Your Money Market Product has been created successfully.",
      primaryButtonText: "Check Details",
      secondaryButtonText: "Close",
      iconBgColor: "#e6f7e9",
      iconColor: "#52c41a",
    },
    warning: {
      title: "Discard changes?",
      message: "Your changes will not be saved if you discard.",
      primaryButtonText: "Discard",
      secondaryButtonText: "Cancel",
      iconBgColor: "#fff7e6",
      iconColor: "#fa8c16",
    },
  };

  // Use provided values or defaults
  const currentTitle = title || defaultValues[type].title;
  const currentMessage = message || defaultValues[type].message;
  const currentPrimaryButtonText =
    primaryButtonText || defaultValues[type].primaryButtonText;
  const currentSecondaryButtonText =
    secondaryButtonText || defaultValues[type].secondaryButtonText;
  const currentIconBgColor = defaultValues[type].iconBgColor;
  const currentIconColor = defaultValues[type].iconColor;

  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      onCancel={onClose}
      width={420}
      centered
      style={{ borderRadius: "12px" }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          textAlign: "start",
        }}
      >
        {/* Icon */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "64px",
            height: "64px",
            borderRadius: "50%",
            backgroundColor: currentIconBgColor,
            marginBottom: "16px",
          }}
        >
          {type === "success" ? (
            <CheckOutlined
              style={{ fontSize: "24px", color: currentIconColor }}
            />
          ) : (
            <ExclamationCircleOutlined
              style={{ fontSize: "24px", color: currentIconColor }}
            />
          )}
        </div>

        {/* Title */}
        <h3 style={{ fontSize: "26px", fontWeight: "600", margin: 0 }}>
          {currentTitle}
        </h3>

        {/* Message */}
        <p
          style={{
            fontSize: "14px",
            color: "#666",
            marginBottom: "24px",
            marginTop: 0,
          }}
        >
          {currentMessage}
        </p>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            // justifyContent: "space-between",
            // gap: "12px",
            width: "100%",
            marginTop: 10,
          }}
        >
          <div style={{ width: "100%" }}>
            {onSecondaryAction && (
              <Button
                style={{
                  // flex: 1,
                  width: "100%",
                  height: "40px",
                  borderRadius: "8px",
                  backgroundColor: "#15CCAE",
                  border: "1px solid #BA24D5",
                  color: "white",
                  fontWeight: 600,
                }}
                fullWidth
                onClick={onSecondaryAction}
              >
                {currentSecondaryButtonText}
              </Button>
            )}
          </div>
          {/* <div style={{ width: "47%" }}>
            {onPrimaryAction && (
              <Button
                type="primary"
                style={{
                  width: "100%",
                  height: "40px",
                  backgroundColor: "#15CCAE",
                  border: "1px solid #BA24D5",
                  borderRadius: "8px",
                  fontWeight: 600,
                }}
                onClick={onPrimaryAction}
              >
                {currentPrimaryButtonText}
              </Button>
            )}
          </div> */}
        </div>
      </div>
    </Modal>
  );
};

export default FeedbackModal;
